import { StatusOption } from '../../utils'

export enum OLTypeEnum {
  LEC = 'LEC',
  PARTNER = 'PARTNER',
  RESIDENCE = 'RESIDENCE',
  DIVERS = 'DIVERS'
}

export const olTypeEnumMapping: Record<OLTypeEnum, StatusOption> = {
  LEC: {
    label: 'LEC',
    variant: 'darkBlue'
  },
  PARTNER: {
    label: 'Partenaire',
    variant: 'warning'
  },
  RESIDENCE: {
    label: 'Résidence',
    variant: 'blue'
  },
  DIVERS: {
    label: 'Divers',
    variant: 'violet'
  }
}
